import { NgModule } from '@angular/core';
import { GetRouteDirective } from '../get-route.directive';
import { SetAspectRatioDirective } from '../set-aspect-ratio.directive';
import { ImagePick } from '../image-pick.directive';
import { MediaTagDirective } from '../mediatag-directive.directive';
import { ImageBack } from '../image-back.directive';
import { IsOnScreen } from '../is-on-screen.directive';
import { VdgmRouterLinkWithHref, VdgmRouterLink } from '../vdgm-router-link.directive';
import { VdgmHLS } from '../vdgm-hls.directive';
import { SlidePositionDirective } from '../slide-position.directive';
import { TrackPushNotifications } from '../track-pn-notifications.directive';
@NgModule({
    declarations: [
        GetRouteDirective,
        SetAspectRatioDirective,
        ImagePick,
        MediaTagDirective,
        ImageBack,
        VdgmRouterLinkWithHref,
        VdgmRouterLink,
        IsOnScreen,
        VdgmHLS,
        SlidePositionDirective,
        TrackPushNotifications
    ],
    imports: [],
    exports: [
        GetRouteDirective,
        SetAspectRatioDirective,
        ImagePick,
        MediaTagDirective,
        ImageBack,
        VdgmRouterLinkWithHref,
        VdgmRouterLink,
        IsOnScreen,
        VdgmHLS,
        SlidePositionDirective,
        TrackPushNotifications
    ]
})

export class SharedDirectivesModule { }


// WEBPACK FOOTER //
// ./src/angular-shared-features/feature/shared-directives/module/shared.directives.module.ts